"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = require("@jsluna/modal");

var _button = require("@jsluna/button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DeleteBranchesModal = function DeleteBranchesModal(_ref) {
  var setIsOpen = _ref.setIsOpen,
      isOpen = _ref.isOpen,
      questions = _ref.questions,
      setQuestions = _ref.setQuestions,
      handleBranchQuestionDelete = _ref.handleBranchQuestionDelete;
  var initialValues = questions;

  var _handleClose = function handleClose() {
    // set questions back to initial questions if cancelled and close modal
    setQuestions(initialValues);
    setIsOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    open: isOpen,
    handleClose: function handleClose() {
      return _handleClose(false);
    },
    small: true
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "ln-u-color-red ln-u-text-align-center ln-u-font=weight-bold ln-u-text-decoration-underline"
  }, "Warning"), /*#__PURE__*/_react.default.createElement("p", null, "Deleting this question will also delete any question which is a branch of this one."), /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    onClick: function onClick() {
      return _handleClose();
    },
    className: "ln-u-margin-bottom"
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    fullWidth: true,
    onClick: function onClick() {
      return handleBranchQuestionDelete();
    }
  }, "Delete"));
};

DeleteBranchesModal.propTypes = {
  /** Array containing the information of each question */
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    })
  })).isRequired,

  /** Function to amend the current list of questions */
  setQuestions: _propTypes.default.func.isRequired,

  /** Indicates whether the modal should be open or not */
  isOpen: _propTypes.default.bool.isRequired,

  /** Function to control the value of isOpen */
  setIsOpen: _propTypes.default.func.isRequired,

  /** Function to handle the deletion of a branched question */
  handleBranchQuestionDelete: _propTypes.default.func.isRequired
};
var _default = DeleteBranchesModal;
exports.default = _default;